import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'src/components/ui/card';
import { Skeleton } from 'src/components/ui/skeleton';

export const TokenHoldingsOverviewSkeleton = () => {
  return (
    <Card className="mx-auto w-full max-w-[1500px] rounded-lg border border-muted-50 bg-background bg-white shadow-[0_0_10px_rgba(0,0,0,0.1)] dark:border-muted-200">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium uppercase text-muted-foreground">
            Token Holdings
          </CardTitle>
          <Skeleton className="h-[22px] w-36 rounded-full" />
        </div>
      </CardHeader>

      <CardContent>
        <div className="flex gap-6">
          {/* TokenHoldingsDropdown skeleton - match Button variant="outline" */}
          <div className="flex-shrink-0">
            <Skeleton className="h-12 w-[26rem] rounded-full" />
          </div>

          {/* TokenAssetAllocationBreakdown skeleton - horizontal bar + legend */}
          <div className="flex-1 space-y-3">
            {/* Horizontal bar chart */}
            <Skeleton className="h-4 w-full rounded-full" />

            {/* Legend items */}
            <div className="flex flex-wrap gap-x-4 gap-y-2">
              {Array.from({ length: 7 }).map((_, index) => (
                <div key={index} className="flex items-center gap-2">
                  <Skeleton className="h-4 w-3 rounded-sm" />
                  <Skeleton className="h-4 w-16" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
